import { useSelector } from "react-redux";
import get from "lodash/get";
import { SUBSCRIBE_PAGE_TEXT } from "../../../../constants";

/**
 * Helper to determine if a subscription is functionally active.
 * Checks for "active" status, or "cancelled" status with a future end date.
 */
export const isSubscriptionActive = (sub) => {
  if (!sub) return false;
  if (sub.status === "active" || sub.status === "ACTIVE") return true;
  if (sub.status === "cancelled" || sub.status === "CANCELLED" || sub.cancelled === true) {
    const endTime = sub.end_timestamp || sub.end_date || sub.previous_end_timestamp;
    if (endTime && new Date(endTime).getTime() > Date.now()) return true;
  }
  return false;
};

/**
 * Hook to evaluate the state of subscription plan cards on page load.
 * Checks SSO authentication and active AccessType subscriptions.
 */
export const useSubscriptionState = (localSubscriptions = []) => {
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));
  const reduxSubscriptions = useSelector((state) =>
    get(state, ["accessTypeData", "subscriptions"], get(state, ["user", "subscriptions"], []))
  );

  const subscriptions = localSubscriptions.length > 0 ? localSubscriptions : reduxSubscriptions;

  const getPlanCardState = (planId, defaultCtaText, isGrey = false) => {
    // State A & B: User is not logged in OR has no subscriptions
    if (!isUserLogin || !subscriptions || subscriptions.length === 0) {
      return {
        text: defaultCtaText || "Buy Now",
        isDisabled: false,
        style: {}
      };
    }

    // Determine if the user has this plan active
    const activeSub = subscriptions.find(sub => {
      const isMatchingPlan = ((sub.plan && String(sub.plan.id) === String(planId)) || String(sub.plan_id) === String(planId) || String(sub.subscription_plan_id) === String(planId));
      if (!isMatchingPlan) return false;
      return isSubscriptionActive(sub);
    });

    // State C: User is authenticated, has active subscription, and it matches this plan
    if (activeSub) {
      return {
        text: "Current Plan",
        isDisabled: true,
        style: { background: "#999", color: "#FFF", pointerEvents: "none", borderColor: "transparent" }
      };
    }

    if (isGrey) {
      return {
        text: defaultCtaText || "Buy Now",
        isDisabled: true,
        style: { background: "#999", color: "#FFF", pointerEvents: "none", borderColor: "transparent" }
      };
    }

    // State D: User is authenticated, has active sub, but it does NOT match this plan
    return {
      text: defaultCtaText || "Buy Now",
      isDisabled: false,
      style: {}
    };
  };

  return { getPlanCardState };
};
